
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'MountedExecute',
  async mounted() {
    this.$emit('nowMounted');
  },
  emits: ['nowMounted']
});
